import React, { ChangeEvent, forwardRef, useCallback, useState } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

/**
 * Props for <NewSelectionList>.
 */
interface NewSelectionListProps {
    /**
     * Creates a new selection list with the given name.
     */
    readonly onCreateSelectionList: (name: string) => void;
}

export const NewSelectionList = forwardRef<HTMLInputElement, NewSelectionListProps>(
    ({ onCreateSelectionList }, ref) => {
        const [newSelectionListName, setNewSelectionListName] = useState('');

        const createNewSelectionList = useCallback(() => {
            if (isEmpty(newSelectionListName)) {
                return;
            }
            onCreateSelectionList(newSelectionListName);
            setNewSelectionListName('');
        }, [newSelectionListName, onCreateSelectionList]);

        const onNewSelectionKeyPress = useCallback(
            (event: React.KeyboardEvent) => {
                if (event.key === 'Enter') {
                    createNewSelectionList();
                }
                if (event.key === 'Escape') {
                    setNewSelectionListName('');
                }
            },
            [createNewSelectionList]
        );

        const onNewSelectionChange = (event: ChangeEvent<HTMLInputElement>) =>
            setNewSelectionListName(event.target.value);

        return (
            <div
                className={classNames(
                    'add-selection',
                    'display-flex',
                    'active',
                    newSelectionListName.length > 0 && 'checked'
                )}
                style={{ height: '20px' }}
            >
                <i className="material-icons fl-left normal cold-bgreen" style={{ fontSize: '14px', height: '20px' }}>
                    content_paste
                </i>
                <input
                    ref={ref}
                    type="text"
                    placeholder="Enter name..."
                    value={newSelectionListName}
                    onKeyUp={onNewSelectionKeyPress}
                    onChange={onNewSelectionChange}
                />
                <a onClick={createNewSelectionList} className="icn-bt">
                    <i className="material-icons fl-right normal">done</i>
                </a>
            </div>
        );
    }
);
